import { useMemo } from 'react'
import { defineMessages, useIntl } from 'react-intl'

import type { HTMLMeta } from '@app/constants/StoreTypes'

type Meta = Partial<HTMLMeta>

export const useFaqMeta = (): Meta => {
  const { formatMessage } = useIntl()
  return useMemo(
    () => ({
      title: formatMessage(messages.faq_title),
      description: formatMessage(messages.faq_description),
      keywords: formatMessage(messages.faq_keywords),
    }),
    [formatMessage]
  )
}

export const useContactsMeta = (): Meta => {
  const { formatMessage } = useIntl()
  return useMemo(
    () => ({
      title: formatMessage(messages.contacts_title),
      description: formatMessage(messages.contacts_description),
      keywords: formatMessage(messages.contacts_keywords),
    }),
    [formatMessage]
  )
}

const messages = defineMessages({
  faq_title: { id: "store.selectors.staticPagesMetaSelector.messages.faq_title.f06e", defaultMessage: 'Ответы на\u00a0часто задаваемые вопросы' },
  faq_description: { id: "store.selectors.staticPagesMetaSelector.messages.faq_description.1641", defaultMessage: 'На\u00a0этой странице можно ознакомиться с\u00a0ответами на\u00a0часто задаваемые вопросы, касающиеся сервиса Kidsout.' },
  faq_keywords: { id: "store.selectors.staticPagesMetaSelector.messages.faq_keywords.2720", defaultMessage: 'Часто задаваемые вопросы, faq' },
  contacts_title: { id: "store.selectors.staticPagesMetaSelector.messages.contacts_title.def9", defaultMessage: 'Контакты Kidsout' },
  contacts_description: { id: "store.selectors.staticPagesMetaSelector.messages.contacts_description.d5eb", defaultMessage: 'Номер телефона для родителей\u00a0— 8\u00a0(800) 707-80-97, E-mail службы клиентской поддержки\u00a0— help@kidsout.ru.' },
  contacts_keywords: { id: "store.selectors.staticPagesMetaSelector.messages.contacts_keywords.ad21", defaultMessage: 'Контакты Kidsout, контактные данные Kidsout' },
})
